(function () {
    'use strict';
    angular.module('Directives').directive('notificationsList', notificationsList);
    notificationsList.$inject = ['NotificationsService'];

    function notificationsList(NotificationsService) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/top-nav/notifications-list.html',
            scope: {
                data: '='
            },
            link: notificationsListLink
        }

        function notificationsListLink($scope) {
            $scope.notifications = [];
            $scope.downloadFile = downloadFile;
            $scope.clearError = clearError;

            init();

            function init() {
                $scope.$watch('data', (value) => {
                    $scope.notifications = value;
                });

                updateNotifData();
            }

            function downloadFile(data) {
                NotificationsService.removeNotifications(data);
                window.open(data.url);
            }

            function clearError(data) {
                NotificationsService.removeNotifications(data);
            }

            function updateNotifData() {
                setInterval(() => {
                    NotificationsService.updateNotificationDuration();
                    NotificationsService.removeExpiredNotifications();
                }, 60000);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/top-nav/notificationsList.js